module.exports = __webpack_public_path__ + "static/media/hair-dryer.7f7a8d18.svg";